<template>
  <div v-if="unexpectedErrorMessages.length" class="form-error">
    <div class="alert alert-danger d-flex flex-column w-100">
        <span v-for="(message, index) in unexpectedErrorMessages"
              :key="index"
        >
          {{ message }}
        </span>
    </div>
  </div>
</template>
<script setup>
import {computed, inject} from "vue";

const errors = inject('form:errors');
const fields = inject('form:fields');
const unexpectedErrorMessages = computed(() => {
  return Object.keys(errors).filter((field) => {
    return fields.indexOf(field) === -1;
  }).map((field) => {
    return errors[field];
  })
});
</script>
<style lang="scss" scoped>
@import "@/css/functions";
@import "@/css/variables";

.form-error {
  display: flex;
  padding: 0 spacing(5);
}
</style>